import {
  getStatViewC,
} from '@/api/salesStat'
import {
  getCustomerFullDetailById,
} from '@/api/customer'
import Vue from 'vue'

const state = {
  statViewC: [],
  statViewCCounts: 0,
  selectedCustomer: null,
  monthlyVolStat: [],
  monthlyReceiveStat: [],
  sixtyDayOrders: [],
  receiveList: [],
  salesStat: [],
  artableDate: {},
}

const getters = {
  // datasource的格式模板
  // return [
  //   ['product', '2015', '2016', '2017'],
  //   ['Matcha Latte', 43.3, 85.8, 93.7],
  //   ['Milk Tea', 83.1, 73.4, 55.1],
  //   ['Cheese Cocoa', 86.4, 65.2, 82.5],
  //   ['Walnut Brownie', 72.4, 53.9, 39.1]
  // ]
  monthlyVolStatChartDataSource: (state) => {
    const finalData = [['月份']];
    for (let month = 1; month < 13; month++) {
      finalData.push([`${month}月`])      
    }
    for (const volStat of state.monthlyVolStat) {
      const index = volStat._id.month;
      finalData[index].push(volStat.volPlanSum.toFixed(0))
    }
    return finalData;
  },
  monthlyReceiveStatChartDataSource: (state) => {
    const finalData = [['月份']];
    for (let month = 1; month < 13; month++) {
      finalData.push([`${month}月`])      
    }
    for (const stat of state.monthlyReceiveStat) {
      const index = stat._id.month;
      finalData[index].push((stat.amount/10000).toFixed(0))
    }
    return finalData;
  },
}

const actions = {
  async getStatViewCAction({ commit }, payload) {
    try {
      const res = await getStatViewC(payload)
      commit('SET_STAT_VIEW_C', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async selectCustomerAction({ commit }, customer) {
    try {
      commit('SET_SELECTED_CUSTOMER', customer)
      const res = await getCustomerFullDetailById(customer._id)
      commit('SET_SELECTED_CUSTOMER', res.data.customer)
      commit('SET_CUSTOMER_DETAIL', res.data)
      return customer
    } catch (error) {
      throw error.message
    }
  },
}

const mutations = {
  SET_STAT_VIEW_C(state, payload) {
    state.statViewC = payload.salesStat
    state.statViewCCounts = payload.totalCounts
  },
  SET_SELECTED_CUSTOMER(state, payload) {
    state.selectedCustomer = payload
  },
  SET_CUSTOMER_DETAIL(state, payload) {
    state.monthlyVolStat = payload.monthlyVolStat
    state.monthlyReceiveStat = payload.monthlyReceiveStat
    state.sixtyDayOrders = payload.sixtyDayOrders
    state.receiveList = payload.receiveList
    state.salesStat = payload.salesStat
    state.artableDate = payload.artableDate
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}